import styled, { css } from 'styled-components';
import { ContinueButton } from '@bookingForm/styles/buttons';
import StyledBand from '@widgets/GenericBookings/components/AttendeesSelector/components/Band/styles';
import { DummyLink } from '@genericBookings/components/SelectedOption/styles';
export const TextButton = styled.button `
  appearance: none;
  -webkit-appearance: none;
  display: inline;
  padding: 0;
  margin: 0;
  background-color: transparent;
  border:none;
  text-decoration: underline;
`;
// ${Wrapper}{
//   width: auto;
//   margin-bottom: 2rem;
//   margin-left: -1rem;
//   margin-right: -1rem;
// }
// <ActionsProps>
export const Actions = styled.div `
  display: block;
  ${({ theme: { attendeesActions } }) => attendeesActions}
  
  ${ContinueButton}{
    margin-top: 1.7rem;
    
    &:first-child {
      margin-top: 0;
    }
  }
  
`;
// ${({ visible }) => visible && css`
//   display: block;
// `}
export const Element = styled.div `
  ${StyledBand.Name}{
    ${({ theme: { attendeeTitle } }) => attendeeTitle}
  }
  
  ${StyledBand.Note}{
    ${({ theme: { attendeeCopy } }) => attendeeCopy}
  }

  ${(props) => {
    const { loggedIn } = props;
    if (loggedIn) {
        return css `
        ${Actions} {
          margin-top: 2rem;
        }
      `;
    }
}}
  
  ${DummyLink} {
    display: block;
    text-align: center;
    margin: 1.5rem 0 2rem;
    
    .winter-wonderland-page & {
      color: var(--primary-light);
    }
  }
`;
